import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion"

import InlineLinkListItem from "@atoms/InlineLinkListItem/InlineLinkListItem"
import JsonLd from "@atoms/JsonLd/JsonLd"

import styles from "./Accordion.module.scss"

const simpleHash = (str) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash &= hash // Convert to 32bit integer
  }
  return new Uint32Array([hash])[0].toString(36)
}

const ModifiedAccordion = ({ title, items, structuredData }) => {
  const hash = simpleHash(JSON.stringify(items).split(0, 140)[0])

  const accordionItems = items.map((item, index) => {
    return (
      <AccordionItem
        key={index}
        uuid={`${hash}-${index}`}
        className={styles.item}
      >
        <AccordionItemHeading className={styles.heading} aria-level="3">
          <AccordionItemButton>{item.heading}</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel className={styles.panel}>
          <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
          {item.link && (
            <div className={styles.link}>
              <InlineLinkListItem
                href={item.link.url}
                text={item.link.title}
                element="p"
                internal={item.link.target !== "_blank"}
              />
            </div>
          )}
        </AccordionItemPanel>
      </AccordionItem>
    )
  })

  const json =
    structuredData === "FAQPage"
      ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: items.map((item, i) => {
            return {
              "@type": "Question",
              name: item.heading,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.content,
              },
            }
          }),
        }
      : null

  return (
    <section className={styles.element}>
      <div className={styles.container}>
        <h2>{title}</h2>
        <Accordion
          onChange={(uuids) => {
            const id = uuids[0]

            const element = document.querySelector(
              `[aria-controls='accordion__panel-${id}']`
            )
            if (element) {
              const headerOffset = 125
              const elementPosition = element.getBoundingClientRect().top
              const offsetPosition =
                elementPosition + window.pageYOffset - headerOffset

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              })
            }
          }}
          className={styles.accordion}
          allowZeroExpanded
        >
          {accordionItems}
        </Accordion>
      </div>
      {json && <JsonLd json={json} />}
    </section>
  )
}

export default ModifiedAccordion
